<template>
  <ts-card>
    <div class="parent-pickup-display">
      <div class="parent-pickup-display__header">
        <div class="parent-pickup-display__header__logo-box">
          <img
            class="parent-pickup-display__header__logo-box__logo"
            :src="logo_file_src"
          />
          <span
            class="parent-pickup-display__header__logo-box__company-name-kh"
            >{{ company.company_name_kh }}</span
          >
          <span
            class="parent-pickup-display__header__logo-box__company-name-en"
            >{{ company.company_name_en }}</span
          >
        </div>
        <div class="ts-m-auto text-center">
          <span class="parent-pickup-display__header__title-kh">{{
            $t('pickupdisplay.សូមអញ្ជើញទៅផ្ទះ')
          }}</span>
          <span class="parent-pickup-display__header__title-en">{{
            $t('pickupdisplay.pleaseGoHome')
          }}</span>
          <!-- <span class="parent-pickup-display__header__title-en"
            >Number called {{ number_of_called }}</span
          > -->
        </div>
        <div class="parent-pickup-display__header__time">
          <span>{{ currentDate }}</span>
          <br />
          <span>{{ currentTime }}</span>
          <br />
          <span>{{ branch.branch_name_en }}</span>
          <a
            href="#"
            @click.prevent="clickClose"
            class="ts-absolute ts-text-lg btn btn-default btn-icon btn-circle"
            style="right: 1px; top: 135px"
          >
            <i class="fas fa-times"></i>
          </a>
        </div>
      </div>
      <div class="parent-pickup-display__body ts-items-center">
        <div class="inner-wrap-body">
          <div class="section-1">
            <div class="photo-wrapper ts-relative">
              <img
                class="ts-rounded"
                v-lazy="{
                  src: photoStudent,
                  error: onErrorStudent
                }"
                onload="this.style.opacity='1';"
              />
              <div
                class="
                  ts-absolute ts-bottom-0 ts-w-full
                  info-box
                  ts-flex ts-items-end
                "
              >
                <h5 class="title ts-text-center" style="margin: 0 auto">
                  <b class="student-name">{{
                    student_name ? student_name : 'Student Name'
                  }}</b>
                  <br />
                  <b class="grade-and-relationship">{{
                    student_grade_name ? student_grade_name : 'Grade Name'
                  }}</b>
                </h5>
              </div>
            </div>
          </div>
          <div class="section-2">
            <div class="photo-wrapper ts-relative">
              <img
                class="ts-rounded"
                v-lazy="{
                  src: guardianPhoto,
                  error: onError
                }"
                onload="this.style.opacity='1';"
              />
              <div
                class="
                  ts-absolute ts-bottom-0 ts-w-full
                  info-box
                  ts-flex ts-items-end
                "
              >
                <h5 class="title ts-text-center" style="margin: 0 auto">
                  <b class="student-name">{{
                    guardian_name ? guardian_name : 'Guardian Name'
                  }}</b>
                  <br />
                  <b class="grade-and-relationship">{{
                    guardian_relationship
                      ? guardian_relationship
                      : 'Relationship'
                  }}</b>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="parent-pickup-display__footer">
        <div class="parent-pickup-display__footer__gate">
          <span class="parent-pickup-display__footer__gate__name-kh"
            >{{ $t('pickupdisplay.ច្រកចេញGate') }}
            {{ deviceName ? deviceName : 'Not Specify' }}</span
          >
        </div>
        <marquee
          scrollamount="10"
          class="parent-pickup-display__footer__company-info"
        >
          <span>
            {{ company.company_name_en }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <i class="fas fa-phone-volume"></i>
            {{ branch.phone }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <i class="fas fa-envelope"></i>
            {{ branch.email }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <i class="fas fa-globe"></i>
            {{ branch.website }}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <i class="fas fa-map-marker-alt"></i>
            {{ branch.address }}
          </span>
        </marquee>
        <div class="parent-pickup-display__footer__powered-by">
          <span
            class="parent-pickup-display__footer__powered-by__company-name"
            >{{ $t('pickupdisplay.poweredbyTechstoreCreativeSolutions') }}</span
          >
          <span class="parent-pickup-display__footer__powered-by__website">
            <a href="https://www.techstore.asia/">{{
              $t('pickupdisplay.wwwtechstoreasia')
            }}</a>
          </span>
        </div>
      </div>
    </div>
  </ts-card>
</template>

<script>
import moment from 'moment'
import { isEmpty } from 'lodash'

export default {
  name: 'pickup-display',
  props: {
    repeatCall: {
      type: Number
    },
    intervalCall: {
      type: Number
    },
    deviceId: {
      type: Number
    },
    deviceName: {
      type: String
    },
    suffix_audio: {
      type: String
    },
    company: {
      type: Object
    },
    branch: {
      type: Object
    }
  },
  data() {
    return {
      student_id: 0,
      student_name: '',
      gender: '',
      student_photo: '',
      student_grade_name: '',
      guardian_name: '',
      guardian_photo: '',
      guardian_relationship: '',
      audio_file_name: '',
      suffixAudio: new Audio(this.suffix_audio),
      times: 0,
      shouldPlaySuffix: true,
      currentDate: '',
      currentTime: '',
      manPhoto: require('@/assets/staff-default-man.png'),
      womenPhoto: require('@/assets/staff-default-women.png'),
      defaultStudentPhoto: require('@/assets/student_default.png'),
      defaultGuardianPhoto: require('@/assets/guardian_default.png'),
      boyPhoto: require('@/assets/student-default-boy.png'),
      girlPhoto: require('@/assets/student-default-girl.png'),
      logo_file_src:
        'http://www.cgmsurgelati.it/wp-content/uploads/2017/09/loading.png',
      calling_time: null,
      // number_of_called: 0
    }
  },
  computed: {
    photoStudent() {
      if (this.student_photo) {
        return this.student_photo
      }
      if (this.gender == 'Male') {
        return this.boyPhoto
      }
      if (this.gender == 'Female') {
        return this.girlPhoto
      }

      return this.defaultStudentPhoto
    },
    guardianPhoto() {
      if (this.guardian_photo) {
        return this.guardian_photo
      }
      if (this.guardian_relationship == 'Father') {
        return this.manPhoto
      }
      if (this.guardian_relationship == 'Mother') {
        return this.womenPhoto
      }
      if (this.guardian_relationship == 'Other') {
        return this.defaultGuardianPhoto
      }

      return this.defaultGuardianPhoto
    }
  },
  created() {
    setInterval(() => this.updateCurrentTime(), 1 * 1000)
    this.logo_file_src = this.company.image_logo
  },
  mounted() {
    this.loadPickup()
    this.onPlaySuffix()
  },
  methods: {
    onError(event) {
      if (event) {
        if (this.guardian_relationship == 'Father') {
          event.target.src = this.manPhoto
        }
        if (this.guardian_relationship == 'Mother') {
          event.target.src = this.womenPhoto
        }
        if (this.guardian_relationship == 'Other') {
          event.target.src = this.defaultGuardianPhoto
        }
      }
    },
    onErrorStudent(event) {
      if (event) {
        if (this.gender == 'Male') {
          event.target.src = this.boyPhoto
        }
        if (this.gender == 'Female') {
          event.target.src = this.girlPhoto
        }
        if (this.gender == '') {
          event.target.src = this.defaultStudentPhoto
        }
      }
    },
    updateCurrentTime() {
      this.currentDate = moment().format('dddd, MMMM Do YYYY')
      this.currentTime = moment().format('LTS')
    },
    async loadPickup() {
      this.times = 0
      // this.number_of_called = this.number_of_called + 1
      let { data } = await this.$store
        .dispatch('pickupDisplay/getStudent', {
          student_id: this.student_id,
          device_id: this.deviceId
        })
        .catch(error => {
          this.$toasted.error('Unauthenticated or No Internet Connection!')
          this.times = -1
          return Promise.reject(error)
        })

      if (data !== null && !isEmpty(data)) {
        this.setStudent(data)
        this.times = this.times + 1
      } else {
        this.times = -1
      }
    },
    setStudent(student) {
      this.student_id = student.student_id
      this.student_name = student.student_name
      this.gender = student.gender
      this.student_photo = student.student_photo
      this.student_grade_name = student.grade_name
      this.guardian_name = student.guardian_name
      this.guardian_photo = student.guardian_photo
      this.guardian_relationship = student.relationship
      this.audio_file_name = student.audio_file_name
      this.calling_time = student.calling_time
    },
    resetStudent() {
      this.student_id = 0
      this.student_name = ''
      this.gender = ''
      this.student_photo = ''
      this.student_grade_name = ''
      this.guardian_name = ''
      this.guardian_photo = ''
      this.guardian_relationship = ''
      this.audio_file_name = ''
    },
    playSound() {
      let audio1 = new Audio(this.audio_file_name)
      audio1.addEventListener('canplaythrough', () => {
        audio1.play()
      })
      audio1.addEventListener(
        'ended',
        () => {
          if (this.shouldPlaySuffix) {
            if (this.suffix_audio) {
              this.suffixAudio.play()
            } else {
              this.times = this.times + 1
            }
          } else {
            this.times = this.times + 1
          }
        },
        false
      )

      audio1.addEventListener(
        'error',
        () => {
          this.times = 0
          this.loadPickup()
        },
        false
      )
    },
    onPlaySuffix() {
      this.suffixAudio.addEventListener(
        'ended',
        () => {
          this.times = this.times + 1
        },
        false
      )

      this.suffixAudio.addEventListener(
        'error',
        () => {
          this.shouldPlaySuffix = false
        },
        false
      )
    },
    clickClose() {
      this.$store.commit('pickupDisplay/SET_CLICK_CLOSE', true)
      this.$emit('close')
    }
  },
  watch: {
    times(newVal) {
      if (newVal > 0 && newVal <= this.repeatCall) {
        this.playSound()
      } else if (newVal > this.repeatCall) {
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.loadPickup()
        }, this.intervalCall)
      } else if (newVal === -1) {
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.resetStudent()
          this.loadPickup()
        }, this.intervalCall)
      }
    }
  }
}
</script>

<style lang="scss">
@media screen and (max-width: 1366px) {
  .v--modal-overlay {
    z-index: 9999;
  }
  .parent-pickup-display {
    color: white;
    &__header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1px 10px 1px 24px;
      border-bottom: 2px solid #dddddd;
      background: #00b4db; /* fallback for old browsers */
      background: -webkit-linear-gradient(
        to right,
        #00b4db,
        #0083b0
      ); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(
        to right,
        #00b4db,
        #0083b0
      ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

      &__logo-box {
        width: 16%;
        display: flex;
        flex-direction: column;
        &__logo {
          height: 70px;
          margin: auto;
        }
        &__company-name-kh {
          font-family: 'Khmer OS Muol Light';
          font-size: 0.9rem;
          display: block;
          text-align: center;
          white-space: nowrap;
        }
        &__company-name-en {
          font-size: 0.7rem;
          display: block;
          text-align: center;
          text-transform: uppercase;
          white-space: nowrap;
        }
      }
      &__title-kh {
        font-family: 'Khmer OS Muol Light';
        font-size: 2rem;
        display: block;
        text-align: center;
        text-shadow: 2px 2px 2px rgb(194, 194, 194);
      }
      &__title-en {
        font-size: 1.5rem;
        display: block;
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        text-shadow: 2px 2px 2px rgb(194, 194, 194);
      }
      &__gate {
        font-size: 1rem;
        display: block;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
      }
      &__time {
        text-align: right;
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 35px;
        opacity: 0.8;
      }
    }
    &__footer {
      box-shadow: 0 12px 7px 11px rgba(0, 0, 0, 0.1);
      background-color: #0083b0;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      &__gate {
        background-color: #00b4db;
        font-size: 1.1rem;
        padding: 8px 6px;
        border-right: 2px solid #dddddd;
        -webkit-box-shadow: 12px 2px 18px -11px #aaaaaa;
        -moz-box-shadow: 12px 2px 18px -11px #aaaaaa;
        box-shadow: 12px 2px 18px -11px #aaaaaa;
        &__name-kh {
          font-family: 'Khmer OS Muol Light';
          font-size: 24px;
          display: block;
          text-align: right;
          white-space: nowrap;
          text-shadow: 2px 2px 2px rgb(194, 194, 194);
        }
      }
      &__company-info {
        padding: 8px 0;
        font-size: 1.2rem;
      }
      &__powered-by {
        background-color: #00b4db;
        font-weight: 600;
        padding: 8px 6px;
        border-left: 2px solid #dddddd;
        -webkit-box-shadow: -12px 2px 18px -11px #aaaaaa;
        -moz-box-shadow: -12px 2px 18px -11px #aaaaaa;
        box-shadow: -12px 2px 18px -11px #aaaaaa;
        &__company-name {
          font-size: 11px;
          display: block;
          text-align: left;
          white-space: nowrap;
        }
        &__website {
          font-size: 11px;
          display: block;
          text-align: left;
        }
      }
    }
  }
  .parent-pickup-display {
    &__body {
      background-color: #dee2e6;
      display: flex;
      overflow: hidden;
      height: 78vh;
      .inner-wrap-body {
        flex: 1;
        display: flex;
        .section-1,
        .section-2 {
          width: 50%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          .photo-wrapper {
            height: 66vh;
            .info-box {
              .title {
                color: #fff;
                .student-name {
                  font-size: 2rem;
                }
                .grade-and-relationship {
                  font-size: 1.5rem;
                }
              }
              height: 100px;
              background: -webkit-gradient(
                linear,
                left top,
                left bottom,
                from(rgba(199, 199, 199, 0.01)),
                to(rgba(0, 0, 0, 0.7))
              );
              background: linear-gradient(
                180deg,
                rgba(199, 199, 199, 0.01) 0,
                rgba(0, 0, 0, 0.7)
              );
              position: absolute;
              bottom: 5px;
              width: 99%;
              display: flex;
              align-items: flex-end;
            }
            width: 58%;
            background: #fff;
            border-radius: 5px;
            -webkit-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            -moz-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            padding: 3px;
            position: relative;
            img {
              width: 100%;
              object-fit: contain;
              border-radius: 0.25rem /* 4px */;
              opacity: 0;
              -moz-transition: opacity 3s; /* Firefox 4 */
              -webkit-transition: opacity 3s; /* Safari and Chrome */
              -o-transition: opacity 3s;
              transition: opacity 3s;
            }
          }
        }
        .section-1 {
          .photo-wrapper {
            margin-left: 26%;
          }
        }
        .section-2 {
          .photo-wrapper {
            margin-left: 13%;
          }
        }
      }
    }
  }
}
@media all and (min-width: 1367px) {
  .v--modal-overlay {
    z-index: 9999;
  }
  .parent-pickup-display {
    color: white;
    &__header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 15px 5px 30px;
      border-bottom: 2px solid #dddddd;
      background: #00b4db; /* fallback for old browsers */
      background: -webkit-linear-gradient(
        to right,
        #00b4db,
        #0083b0
      ); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(
        to right,
        #00b4db,
        #0083b0
      ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

      &__logo-box {
        width: 16%;
        display: flex;
        flex-direction: column;
        &__logo {
          height: 113px;
          margin: auto;
        }
        &__company-name-kh {
          font-family: 'Khmer OS Muol Light';
          font-size: 1rem;
          display: block;
          text-align: center;
          white-space: nowrap;
        }
        &__company-name-en {
          font-size: 0.8rem;
          display: block;
          text-align: center;
          text-transform: uppercase;
          white-space: nowrap;
        }
      }
      &__title-kh {
        font-family: 'Khmer OS Muol Light';
        font-size: 2.5rem;
        display: block;
        text-align: center;
        text-shadow: 2px 2px 2px rgb(194, 194, 194);
      }
      &__title-en {
        font-size: 2rem;
        display: block;
        text-align: center;
        text-transform: uppercase;
        font-weight: 700;
        text-shadow: 2px 2px 2px rgb(194, 194, 194);
      }
      &__gate {
        font-size: 1.3rem;
        display: block;
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
      }
      &__time {
        text-align: right;
        height: 113px;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 40px;
        opacity: 0.8;
      }
    }
    &__footer {
      box-shadow: 0 12px 7px 11px rgba(0, 0, 0, 0.1);
      background-color: #0083b0;
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      &__gate {
        background-color: #00b4db;
        font-size: 1.5rem;
        padding: 10px 8px;
        border-right: 2px solid #dddddd;
        -webkit-box-shadow: 12px 2px 18px -11px #aaaaaa;
        -moz-box-shadow: 12px 2px 18px -11px #aaaaaa;
        box-shadow: 12px 2px 18px -11px #aaaaaa;
        &__name-kh {
          font-family: 'Khmer OS Muol Light';
          font-size: 24px;
          display: block;
          text-align: right;
          white-space: nowrap;
          text-shadow: 2px 2px 2px rgb(194, 194, 194);
        }
      }
      &__company-info {
        padding: 10px 0;
        font-size: 1.5rem;
      }
      &__powered-by {
        background-color: #00b4db;
        font-weight: 600;
        padding: 10px 8px;
        border-left: 2px solid #dddddd;
        -webkit-box-shadow: -12px 2px 18px -11px #aaaaaa;
        -moz-box-shadow: -12px 2px 18px -11px #aaaaaa;
        box-shadow: -12px 2px 18px -11px #aaaaaa;
        &__company-name {
          font-size: 12px;
          display: block;
          text-align: left;
          white-space: nowrap;
        }
        &__website {
          font-size: 12px;
          display: block;
          text-align: left;
        }
      }
    }
  }
  .parent-pickup-display {
    &__body {
      background-color: #dee2e6;
      display: flex;
      overflow: hidden;
      height: 80vh;
      .inner-wrap-body {
        flex: 1;
        display: flex;
        .section-1,
        .section-2 {
          width: 50%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          .photo-wrapper {
            height: 69vh;
            .info-box {
              .title {
                color: #fff;
                .student-name {
                  font-size: 2.5rem;
                }
                .grade-and-relationship {
                  font-size: 2rem;
                }
              }
              height: 100px;
              background: -webkit-gradient(
                linear,
                left top,
                left bottom,
                from(rgba(199, 199, 199, 0.01)),
                to(rgba(0, 0, 0, 0.7))
              );
              background: linear-gradient(
                180deg,
                rgba(199, 199, 199, 0.01) 0,
                rgba(0, 0, 0, 0.7)
              );
              position: absolute;
              bottom: 5px;
              width: 99%;
              display: flex;
              align-items: flex-end;
            }
            width: 60%;
            background: #fff;
            border-radius: 5px;
            -webkit-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            -moz-box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            box-shadow: 0px 0px 18px -7px rgba(163, 163, 163, 1);
            padding: 3px;
            position: relative;
            img {
              width: 100%;
              object-fit: contain;
              border-radius: 0.25rem /* 4px */;
              opacity: 0;
              -moz-transition: opacity 3s; /* Firefox 4 */
              -webkit-transition: opacity 3s; /* Safari and Chrome */
              -o-transition: opacity 3s;
              transition: opacity 3s;
            }
          }
        }
        .section-1 {
          .photo-wrapper {
            margin-left: 26%;
          }
        }
        .section-2 {
          .photo-wrapper {
            margin-left: 13%;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.hide-body-scroll {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
</style>
